<template>
    <div class="mask" id="mask">
        <div class="container" :style="{ height: height }">
            <div class="title">
                <div class="title-text">كېلىشىمنامىنى ئوقۇپ چىقىڭ</div>
                <div @click="hide" class="icon iconfont icon-cuowuguanbiquxiao"></div>
            </div>
            <div class="word">
                <p class="text">مەزكۇر سۇپىغا دۆلىتىمىزنىڭ ئالاقىدار قانون نىزاملىرىغا شۇنداقلا يەرلىك سىياسەتكە قارشى ھەرقانداق شەكىلدىكى مەزمۇننى يوللاش چەكلىنىدۇ.</p>
                <p class="text">نەشىر ھوقوقى يوق بولغان مەزمۇنلارنى يوللاپ كېلىپ چىققان قانونى مەسئۇلىيەت ۋە ئىقتىسادىي ماجراغا نىسبەتەن ئاچقۇچى تەرەپ ھىچقانداق قانونىي ۋە ئىقتىسادى مەسئۇلىيەتنى ئۈستىگە ئالمايدۇ.</p>
                <p class="text">سېرىق تۈستىكى مەزمۇنلارنى يوللاپ كېلىپ چىققان قانونى مەسئۇلىيەت ۋە باشقا ماجرالارغا نىسبەتەن ئاچقۇچى تەرەپ ھىچقانداق قانونىي ۋە ئىقتىسادى مەسئۇلىيەتنى ئۈستىگە ئالمايدۇ.</p>
                <p class="text">جەمىئەتتە يامان تەسىر، خاتا كۆز قاراش، خاتا مۇنازىرە پەيدا قىلىدىغان مەزمۇنلارنى يوللاپ كېلىپ چىققان قانونى مەسئۇلىيەت ۋە ئىقتىسادىي ماجراغا نىسبەتەن ئاچقۇچى تەرەپ ھىچقانداق قانونىي ۋە ئىقتىسادى مەسئۇلىيەتنى ئۈستىگە ئالمايدۇ.</p>
                <p class="text">سۇپىنىڭ ئىشلىتىش ۋە باشقۇرۇش ھوقوقى ئىشلەتكۈچى تەرەپتە بولۇپ ئاچقۇچى تەرەپ ھەرقانداق قەدەم باسقۇچقا ئارلاشمايدۇ، يوللانغان بارلىق مەزمۇن پەقەت ئىشلەتكۈچى تەرەپنىڭ قىزىقىشى ۋە مەيدانىنى ئىپادىلەيدۇ، ئاچقۇچى تەرەپنىڭ قىزىقىشى ۋە مەيدانى بىلەن مۇناسىۋەتسىز.</p>
                <p class="text">تور دۇنياسى قانون سىرتىدىكى دۇنيا ئەمەس، ئۇمۇ قانوننىڭ بىردەك قوغداش ۋە جازالاش دائىرىسىدىكى ئاممىۋىي سورۇن بولۇپ، ئىشلەتكۈچى تەرەپ مۇناسىۋەتلىك قانون تۈزۈم ۋە سىياسەتكە بوي سۇنغان ئاساستا مەزكۇر سۇپىنى ئىشلىتىشى كېرەك، قانون تۈزۈم ۋە سىياسەتتىن چەتنەپ كەتكەن، قانونسىز، ئەخلاقسىز، سېرىق تۈستىكى مەزمۇنلارنى يوللاش پۈتۈنلەي چەكلىنىدۇ.</p>
                <p class="text">ئۈستىدە دىيىلگەن ۋە دىيىلمىگەن ھەرقانداق شەكىلدىكى قانونغا ، جامائەت ئەخلاقىغا خىلاپ بولغان مەزمۇنلارنى يوللاش بىردەك چەكلىنىدۇ، ئەگەر شۇنداق مەزمۇنلار يوللىنىپ قالسا بۇ پۈتۈنلەي ئىشلەتكۈچى تەرەپ بىر تەرەپنىڭ مەسئۇلىيىتى، ئاچقۇچى تەرەپ بىلەن مۇناسىۋەتسىز.</p>
                <p class="text">مەزكۇر سۇپىنى ئاچقۇچى تەرەپ، مەزمۇنغا قارىتا قەرەلسىز ھالدا تەكشۈرۈپ تۇرۇشقا ھوقوقلۇق، ناۋادا ئاچقۇچى تەرەپ بىنورمال مەزمۇننىڭ بارلىقى بايقىسا، ئىشلەتكۈچى تەرەپنى خەۋەرلەندۈرۈپ قويمايلا تازلىۋېتىشكە ھوقوقلۇق.</p>
                <p class="text">مەزكۇر سۇپىنى ئاچقۇچى تەرەپ ئۈندىدار، QQ، 钉钉 ۋە باشقا ئالاقە ۋاستىلىرىدا ئىشلەتكۈچى بىلەن كېلىشكەن باشقا كېلىشىم مەزمۇنىمۇ ئوخشاشلا قانونى كۈچكە ئېگە.</p>
                <p class="text">مەزكۇر سۇپىنى ئىشلەتكىنىڭىز يۇقارقى كېلىشىمگە قوشۇلغانلىقىڭىزنى بىلدۈرىدۇ. كېلىشىمگە خىلاپ ھالدا ئېلىپ بارغان ھەرقانداق مەشغۇلاتىىڭىز پەقەت ئىشلەتكۈچى بولغان سىزنىڭ مەيدانىڭىز ۋە قىزىقىشىڭىزنى ئىپادىلەيدۇ، ئاچقۇچى تەرەپ بىلەن مۇناسىۋەتسىز.</p>
            </div>
            <div class="agree" @click="positive">قوشۇلىمەن</div>
        </div>
    </div>
</template>
<script>
    let self;
    export default {
        created() {
            self = this;
        },
        props: {
            height: {
                type: String,
                value: ""
            }
        },
        methods: {
            positive(){
                self.$emit('positive')
            },
            hide(){
                self.$emit('hide')
            }
        }
    };
</script>
<style lang="less" scoped>
    @import "../assets/less/global.less";
    .mask {
         position: fixed;
         width: 100%;
         height: 100%;
         left: 0;
         top: 0;
         z-index: 999;
         background: rgba(0, 0, 0, 0.382);
         transition: opacity 200ms;
        .container {
            position: relative;
            width: 500px;
            height: 732px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            padding: @margin-size;
            border-radius: @margin-size-small;
            .title {
                font-size: @font-size-large;
                text-align: right;
                background: @color-primary;
                background-size: 120px;
                -webkit-background-clip: text;
                font-weight: 500;
                display: flex;
                align-items: center;
                direction: rtl;
                padding-bottom: @margin-size;
                border-bottom: 1px solid #eee;
               

                .title-text{
                    flex: 1;
                }

                .icon:hover{
                    color: #5867dd;
                }
            }
            .word{
                 

                .text{
                    text-align: right;
                    color: #646c9a;
                }
                :last-child{
                    border-bottom: 1px solid #eee;
                    padding-bottom: @margin-size;
                  
                }
            }
            
            .agree{
                background: #5867dd;
                padding: @margin-size-small;
                width: @margin-size-xl*2;
                color: white;
                border-radius: @radius-size-small;

            }
        }
    }
</style>